<template>
  <div>
    <!--womia box app description and logo-->
    <div class="section pt-4 pb-0">

      <div class="container">
        <div class="d-flex mb-5">
          <div class="mb-0">
            <a href="/beta" class="hero-btn fw-bold  text-decoration-none d-inline-flex align-items-center back-home"
              style="position: relative; color: black;">
              <span>
                <i class="fa fa-fw fa-arrow-left "></i>
              </span>
              Back
            </a>
          </div>
        </div>
      </div>

    </div>
    <div class="section pt-0">
      <div class="container">
        <div class="row gx-0 align-items-center">
          <div class="col-lg-6 mb-4 mb-lg-0">
            <img :src="$options.filters.media(product.logo.slug)" alt="Product Image" class="mw-100"
              style="height: 431px; width: 575px;">
          </div>
          <div class="col-lg-6 px-lg-5">
            <div class="display-5 fw-bolder mb-2">{{ product.name }}</div>
            <div class="fs-20px fw-bold text-gray-600 mb-3 mb-lg-5 textgray" v-html="product.description">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section pt-0 mt-n5 mt-lg-0">

      <div class="container">

        <div class="row">

          <div class="col-6 col-lg-3">
            <div class="fw-bolder display-4">{{ product.created | moment('YYYY') }}</div>
            <div class="fw-bolder h4 text-gray-500 mb-lg-0">created since</div>
          </div>


          <div class="col-6 col-lg-3">
            <div class="fw-bolder display-4 ">{{ product.patient }}</div>
            <div class="fw-bolder h4 text-gray-500 mb-lg-0">Number of studies</div>
          </div>

          <div class="col-6 col-lg-3">
            <div class="fw-bolder display-4 text-capitalize">{{ product.annotated }}</div>
            <div class="fw-bolder h4 text-gray-500 mb-lg-0 ">Annotated</div>
          </div>

          <div class="col-6 col-lg-3">
            <div class="fw-bolder display-4 ">{{ product.age }}</div>
            <div class="fw-bolder h4 text-gray-500 mb-lg-0">Age</div>
          </div>

        </div>

      </div>

    </div>
    <!--Categories-->
    <div class="footer section bg-light">
      <div class="container">
        <div class="row gx-lg-5 ">
          <div v-for="(categoryItems, categoryKey, index) in filteredCategories" :key="categoryKey"
            v-if="categoryItems.length > 0" class="col-lg-2   row-spacing">
            <h4 class="footer-title text-capitalize">{{ formatCategoryTitle(categoryKey) }}
            </h4>
            <ul class="footer-link-list ">
              <li v-for="(item, index) in categoryItems" :key="index"><a href="#" class=" category-tags">{{formatCategoryItem(categoryKey, item) }}</a></li>
            </ul>
          </div>
          <div class="col-lg-2 row-spacing">
            <h4 class="footer-title  ">Device</h4>
            <ul class="footer-link-list">
              <li><a href="#" class=" category-tags  text-capitalize">{{ product.device[0] }}</a></li>
              <li v-if="product.device.length > 1"><a href="#" class=" category-tags  text-capitalize">{{ product.device[1] }}</a>
              </li>
              <li v-if="product.device.length > 2"><a href="#" class=" category-tags  text-capitalize">{{ product.device[2] }}</a>
              </li>
              <li v-if="product.device.length > 3"><a href="#" class="category-tags  text-capitalize">{{ product.device[3] }}</a>
              </li>
            </ul>
          </div>
          <div v-if="product.formats && product.formats.length" class="col-lg-2 row-spacing ">
            <h4 class="footer-title ">Format</h4>
            <ul class="footer-link-list">
              <li><a href="#" class="category-tags  text-capitalize">{{ product.formats[0] }}</a></li>
              <li v-if="product.formats.length > 1"><a href="#" class="category-tags  text-capitalize">{{ product.formats[1] }}</a></li>
            </ul>
          </div>
          <div v-if="product.outcomes && product.outcomes.length" class="col-lg-2 mg-lg-0 ">
            <h4 class="footer-title  ">Outcomes</h4>
            <ul class="footer-link-list">
              <li><a href="#" class=" category-tags  text-capitalize">{{ product.outcomes }}</a></li>
            </ul>
          </div>
          <div v-if="product.multiCentric && product.multiCentric.length" class="col-lg-2 mg-lg-0 ">
            <h4 class="footer-title ">Multi Centric</h4>
            <ul class="footer-link-list">
              <li><a href="#" class=" category-tags  text-capitalize">{{ product.multiCentric }}</a></li>
            </ul>
          </div>
          <div v-if="product.contrastEnhanced && product.contrastEnhanced.length" class="col-lg-2 mg-lg-0 ">
            <h4 class="footer-title ">Contrast Enhanced</h4>
            <ul class="footer-link-list">
              <li><a href="#" class=" category-tags  text-capitalize">{{ product.contrastEnhanced }}</a></li>
            </ul>
          </div>
          <div v-if="product.multiDevice && product.multiDevice.length" class="col-lg-2 mg-lg-0">
            <h4 class="footer-title ">Multi Device</h4>
            <ul class="footer-link-list">
              <li><a href="#" class=" category-tags  text-capitalize">{{ product.multiDevice }}</a></li>
            </ul>
          </div>
          <div v-if="product.followUp && product.followUp.length" class="col-lg-2 mg-lg-0">
            <h4 class="footer-title ">Follow Up</h4>
            <ul class="footer-link-list">
              <li><a href="#" class=" category-tags  text-capitalize">{{ product.followUp }}</a></li>
            </ul>
          </div>
          <div v-if="product.gender && product.gender.length" class="col-lg-2 mg-lg-0 ">
            <h4 class="footer-title ">Gender</h4>
            <ul class="footer-link-list">
              <li><a href="#" class=" category-tags text-capitalize">{{ product.gender }}</a></li>
            </ul>
          </div>

          <div v-if="product.country && product.country.length" class="col-lg-2 mg-lg-0">
            <h4 class="footer-title">Country</h4>
            <ul class="footer-link-list">
              <li v-for="(country, index) in splitCountries" :key="index">
                <a href="#" class="category-tags text-capitalize">{{ country }}</a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>

<div class="section with-logo p-0 ">
    <!--new demo-->
    <div class="section  ">
      <div class="container">
        <div data-v-49f1c9d8="" class="col-lg-12 ">
          <div data-v-49f1c9d8="" class="news ask-demo bg-light rounded-3 overflow-hidden shadow-lg mb-5 mb-lg-0">
            <div class="container ">
              <div class="pt-lg-5 pb-lg-3 text-center">
                <b>
                  <div class="display-6 fw-bolder mb-3 d-flex align-items-center justify-content-center">
                    Start discovering the data
                  </div>
                </b>
                <div class="sparator" style=" border-bottom: 1px solid rgba(0, 0, 0, 0.2); margin: 0 280px 17px;"></div>
              </div>
            </div>

            <div class="container">
              <div class="row justify-content-center">
                <div class="col-lg-10">
                  <div class="row gx-lg-5 ">
                    <div class="col-lg-3"></div>
                    <div class="col-lg-6 pb-lg-5">
                      <!-- Show "Ask A Demo" button if not authenticated -->
                      <button type="button" v-if="!purchase" @click.prevent.stop="install"
                        class="btn btn-lg d-flex w-100 btn-primary get-started  rounded-2 fw-bold fs-16px py-3  justify-content-center">
                        Ask access
                      </button>
                      <div v-if="purchase" class="fs-14px mb-3 d-flex align-items-center justify-content-center">
                        You asked an access of {{ product.name }} on
                        {{ purchase.created | moment("YYYY-MM-DD") }}
                      </div>
                      <router-link v-if="purchase"
                        class="btn btn-lg d-flex w-100 btn-primary get-started  rounded-2 fw-bold fs-16px py-3  justify-content-center"
                        :to="{ name: 'Install', params: { id: purchase._id } }">
                        Access Asked
                      </router-link>
                    </div>
                    <div class="col-lg-3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  <!--Publications-->
  <div class="section pt-0" v-if="product.publications && product.publications.length">
    <div class="container">
      <div class="section-subtitle">
        Catalog related to the same studies
      </div>

      <div class="row">
        <div class="col-12">
          <div class="align-items-center">
            <ul class="list-unstyled mb-0">
              <div v-for="pub in product.publications" :key="pub.link" @mouseover="setHovered(pub.link, true)"
                @mouseout="setHovered(pub.link, false)"
                class="p-4 bg-light position-relative border-start border-5 border-warning mb-2 pub.link pub-custom-hover">
                <div :key="pub.link" class="d-flex align-items-center custom">
                  <div>
                    <a :href="pub.link" target="_new" style="color: #2d353c;"><strong>{{ pub.title }}</strong></a>
                  </div>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</template>
<script>
import Rating from "@/components/Rating";
import RatingStats from "@/components/RatingStats";
import Review from "@/components/Review";
import VueGallery from "vue-gallery";
import Vue from "vue";
import Vuex from "vuex";

export default {
  name: "Product",
  data() {
    return {
      product: null,
      images: [],
      index: null,
      purchase: null,
      hoveredItems: {},
      classList: [
        "bg-primary-200 text-theme-800",
        "bg-indigo-200 text-indigo-800",
        "bg-aqua-200 text-aqua-800",
        "bg-red-200 text-red-800",
        "bg-green-200 text-green-800"
      ],
      classIndex: 0,
      categories: {
        modality: ["mri", "xray", "ct", "eeg", "ecg"],
        organ: ["lung", "heart", "liver", "arteries", "trachea", "spine", "pancreas", "spleen", "kidneys", "intestines", "bone", "breast", "teeth", "other"],
        bodyRegion: ["chest", "abdominal", "pelvic", "head", "cervical", "whole-body", "chest abdominal", "chest abdominal pelvic", "cervical chest abdominal pelvic", "chest abdominal pelvic head"],
        pathology: ["healthy", "covid", "nodule", "masse", "fibrosis", "emphysma", "pulmonary interstitial disease", "dilated heart", "thormbus", "atheroma", "dissection", "aneurysm", "pulmonary disease", "arterial disease", "heart disease"],
        orientation: ["axial", "coronal", "sagittal", "short-axis", "long-axis-2-cavities", "long-axis-3-cavities", "long-axis-4-cavities", "multiplanar", "multiplanar-radial", "multiplanar-short-axis"],
        type: ["2D", "2D+T", "2D+t", "3D", "3D+T", "3D+t", "none"],
        age: ["20-30", "30-40", "40-50", "50-60", "60-70", "70-80"],
        protocol: ["chest-", "abdominal-", "pelvic-", "cerebral", "cervical-", "whole-body", "chest-abdominal", "chest-abdominal-pelvic", "cervical-chest-abdominal-pelvic", "chest-abdominal-pelvic-cerebral", "abdominal-pelvic", "cervical spine",
           "Aortic-Angiography", "thoracic-angiography", "supra-aortic-trunks-angiography", "lower-extremity-angiography", "cerebral-angiography", "abdominal-angiography", "thoracic-spine", "lumbar-spine", "coronary","flow-2D", "flow-3D", "cine SSFP", "cardiac-function", "anatomy", "perfusion", "enhancement", "tagging", "angiography", "t1-mapping", "t2-mapping", "t2* mapping", "dixon"],

      }

    };
  },
  components: {
    gallery: VueGallery,
    rating: Rating,
    review: Review,
    "rating-stats": RatingStats
  },
  computed: {
    ...Vuex.mapGetters(["isAuthenticated", "authToken"]),
    filteredCategories() {
      if (!this.product || !this.product.categories) return {};

      const filtered = {};

      // Remove the conversion to lowercase here
      Object.keys(this.categories).forEach(key => {
        filtered[key] = this.product.categories.filter(cat =>
          this.categories[key].includes(cat)
        );
      });

      return filtered;
    },
    splitCountries() {
      return this.product.country.split('#').map(country => country.trim());
    }
  },

  created() {
    this.fetchData();
  },
  watch: {
    product(val) {
      if (this.isAuthenticated) {
        this.checkPurchase();
      }
    }
  },
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  beforeMount() {
    window.scrollTo(0, 0);
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    });
  },
  methods: {
    checkPurchase() {
      this.$http
        .get(`purchase`, {
          params: {
            conditions: { product: this.product._id }
          }
        })
        .then(
          response => {
            this.purchase = response.data[0];
          },
          error => {
            console.log(error);
          }
        );
    },
    getClass(index) {
      const classIndex = index % this.classList.length;
      return this.classList[classIndex];
    },
    fetchData() {
      const viewStatus = {
        edit: { label: "Editing", class: "badge-warning" },
        pending: { label: "Waiting for approval", class: "badge-info" },
        declined: { label: "Declined", class: "badge-danger" },
        approved: { label: "Approved", class: "badge-success" },
        closed: { label: "Closed", class: "badge-default" }
      };

      let productUri = "product/public/";
      /* if (this.isAuthenticated) {
        productUri = 'product/dev/'
      } */
      this.$http
        .get(`${productUri}${this.$route.params.slug}`, {
          params: { populate: "author" }
        })
        .then(
          response => {
            this.product = response.body;
            this.images = (this.product.screenshots || []).map(it =>
              Vue.filter("media")(it.slug, {})
            );
            // formating app status
            this.product.status = viewStatus[this.product.status];
            this.product.logo = this.product.logo || {};
            this.product.videos = this.product.videos || [];
            this.product.reviews = this.product.reviews || [];
          },
          response => {
            console.log(response);
          }
        );
    },
    formatCategoryTitle(title) {
      return title.split(/(?=[A-Z])/).join(' ').replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
    },
    formatCategoryItem(categoryKey, item) {
      if (categoryKey === 'type') {
        return item;
      }
      return item.split(/(?=[A-Z])/).join(' ').replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
    },
    install() {
      if (!this.isAuthenticated) {
        this.$router.push({
          name: "Login",
          query: { redirect: this.$route.path, section: "askDemoSection" }
        });
      } else {
        this.$http.put(`purchase`, { product: this.product._id }).then(
          response => {
            const purchase = response.data;
            if (purchase.status === "paid") {
              this.$router.push({
                name: "Install",
                params: { id: purchase._id }
              });
            }
            if (purchase.status === "init") {
              console.log("Paid product");
            }
          },
          error => {
            console.log(error);
          }
        );
      }
    },
    setHovered(pubLink, value) {
      this.$set(this.hoveredItems, pubLink, value);
    },
    isHovered(pubLink) {
      return this.hoveredItems[pubLink] || false;
    }
  }
};
</script>

<style scoped>
@media (min-width: 1200px) {
  .container-for-img {
    position: relative;
    width: 450px;
    height: 360px;
  }
}

@media (max-width: 1190px) {
  .container-for-img {
    position: relative;
    width: 450px;
    height: 360px;
  }
}

@media (max-width: 500px) {
  .container-for-img {
    position: relative;
    width: 350px;
    height: 200px;
  }
}

.ecran {
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
}

.logo-ecran {
  position: absolute;
  top: 5.1%;
  left: 4.5%;
  width: 91.5%;
  height: 68.9%;
  z-index: 1;
}

.me-3 {
  margin-right: 0.9375rem !important;
}

@keyframes moveUpDown {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

.scroll-img {
  animation: moveUpDown 2s infinite alternate;
  transition: transform 0.3s ease;
  margin-top: 0.9375rem;
  height: 35px;
}

.scroll-img:hover {
  transform: scale(1.1);
  animation-play-state: paused;
}

.text-center-forscroll {
  text-align: center;
  margin-bottom: 40px;
}

.section-scroll {
  padding-top: 0rem;
  padding-bottom: 2rem;
}

.section.apps {
  padding-bottom: 2rem;
}

a.scroll-image {
  text-decoration: none;
  color: var(--bs-component-color);
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  transition: color 0.2s linear;
  display: inline-block;
  position: relative;
}

.hero-btn .fw-bold .mb-n5.back-home:hover {
  color: rgba(108, 117, 125, 1) !important;
}

.category {
  margin-right: 3px;
}

.back-home:hover,
.back-home:hover .fa {
  color: #494949b3 !important;
}

.news-media-img {
  position: relative;
  width: 100%;
  height: 100%;
}

.news-media-img img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-btn i {
  border: 2px solid rgba(14, 14, 14, 0.5);
  width: 40px;
  height: 40px;
  margin-right: 0.9375rem;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section .section-bg {
  z-index: -1;
}

/*.with-logo {
  background: url("../../assets/logo-shape-dark.svg") no-repeat;
  padding: 0;
}*/

.category-container {
  max-width: 800px;
}

div.textgray {
  color: rgba(108, 117, 125, 1) !important;
}

.border-warning:hover {
  border-color: #E95913 !important;
}

.get-started {
  background: #E95913 !important;
}

.get-started:hover {
  background: #E95913af !important;
}

.row-spacing {
  margin-bottom: 3em;
}

.category-tags:hover {
  color: #2d353c !important;

}
.with-logo {
  background: url("/beta/static/logo-shape.svg") no-repeat;
  background-size: cover;
}
@media (max-width: 993px){
.ask-demo{
  padding-top: 20px;
  padding-bottom:20px ;
}
}
@media (min-width: 2600px) {
  .with-logo {
    background-position-x: right;
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/public/Product.vue